export default __webpack_public_path__ + "static/media/error_server.14e33c1d.svg";